import { Box, CircularProgress, Grid2, Typography } from "@mui/material";
import { BaseLegend } from "../../../components/form/legend/styled";
import { AddGuarantorFormType } from "../../../types/container.type";
import { AddGuarantorWrapper } from "./styled";
import { BaseFieldSet } from "../../../components/form/fieldset/styled";
import { BaseLabel } from "../../../components/form/label/styled";
import { BaseInput } from "../../../components/form/input/styled";
import { BaseButton } from "../../../components/button/styled";

export const AddGuarantor: React.FC<AddGuarantorFormType> = ({
	formDetails,
	setFormDetails,
	error,
	isLoading,
	handleSubmit,
}) => {
	const handleChange = (
		e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
	) => {
		const { name, value } = e.target;
		setFormDetails((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	return (
		<AddGuarantorWrapper onSubmit={handleSubmit}>
			<BaseLegend fontweight={500} fontsize={"18"} color="var(--dark-color)">
				Enter required Information to add guarantor
			</BaseLegend>
			<Grid2
				container
				component={"div"}
				spacing={"var(--flex-gap)"}
				className="fieldset-grid-wrapper"
			>
				<Grid2 size={{ mobile: 12, tablet: 6 }}>
					<BaseFieldSet>
						<BaseLabel colour="var(--dark-color)">
							First Name{" "}
							<Typography
								component={"span"}
								fontFamily={"inherit"}
								fontWeight={"inherit"}
								fontSize={"inherit"}
								lineHeight={"inherit"}
								color={"var(--text-salmon-pink-color)"}
							>
								*
							</Typography>
						</BaseLabel>
						<BaseInput
							required
							name="firstName"
							value={formDetails.firstName}
							placeholder="Enter First Name"
							onChange={(e) => handleChange(e)}
						/>
					</BaseFieldSet>
				</Grid2>
				<Grid2 size={{ mobile: 12, tablet: 6 }}>
					<BaseFieldSet>
						<BaseLabel colour="var(--dark-color)">Middle Name</BaseLabel>
						<BaseInput
							name="middleName"
							value={formDetails.middleName}
							placeholder="Enter Middle Name"
							onChange={(e) => handleChange(e)}
						/>
					</BaseFieldSet>
				</Grid2>
				<Grid2 size={{ mobile: 12, tablet: 6 }}>
					<BaseFieldSet>
						<BaseLabel colour="var(--dark-color)">
							Last Name{" "}
							<Typography
								component={"span"}
								fontFamily={"inherit"}
								fontWeight={"inherit"}
								fontSize={"inherit"}
								lineHeight={"inherit"}
								color={"var(--text-salmon-pink-color)"}
							>
								*
							</Typography>
						</BaseLabel>
						<BaseInput
							required
							name="lastName"
							value={formDetails.lastName}
							placeholder="Enter Last Name"
							onChange={(e) => handleChange(e)}
						/>
					</BaseFieldSet>
				</Grid2>
				<Grid2 size={{ mobile: 12, tablet: 6 }}>
					<BaseFieldSet>
						<BaseLabel colour="var(--dark-color)">
							Email{" "}
							<Typography
								component={"span"}
								fontFamily={"inherit"}
								fontWeight={"inherit"}
								fontSize={"inherit"}
								lineHeight={"inherit"}
								color={"var(--text-salmon-pink-color)"}
							>
								*
							</Typography>
						</BaseLabel>
						<BaseInput
							required
							type="email"
							name="email"
							value={formDetails.email}
							placeholder="Enter Email"
							onChange={(e) => handleChange(e)}
						/>
					</BaseFieldSet>
				</Grid2>
				<Grid2 size={{ mobile: 12, tablet: 6 }}>
					<BaseFieldSet>
						<BaseLabel colour="var(--dark-color)">
							Primary Phone Number{" "}
							<Typography
								component={"span"}
								fontFamily={"inherit"}
								fontWeight={"inherit"}
								fontSize={"inherit"}
								lineHeight={"inherit"}
								color={"var(--text-salmon-pink-color)"}
							>
								*
							</Typography>
						</BaseLabel>
						<BaseInput
							required
							name="primaryPhone"
							value={formDetails.primaryPhone}
							placeholder="Enter Primary Phone Number"
							onChange={(e) => handleChange(e)}
						/>
					</BaseFieldSet>
				</Grid2>
				<Grid2 size={{ mobile: 12, tablet: 6 }}>
					<BaseFieldSet>
						<BaseLabel colour="var(--dark-color)">
							Secondary Phone Number
						</BaseLabel>
						<BaseInput
							name="secondaryPhone"
							value={formDetails.secondaryPhone}
							placeholder="Enter Secondary Phone Number"
							onChange={(e) => handleChange(e)}
						/>
					</BaseFieldSet>
				</Grid2>
				<Grid2 size={{ mobile: 12, tablet: 6 }}>
					<BaseFieldSet>
						<BaseLabel colour="var(--dark-color)">
							Home Address{" "}
							<Typography
								component={"span"}
								fontFamily={"inherit"}
								fontWeight={"inherit"}
								fontSize={"inherit"}
								lineHeight={"inherit"}
								color={"var(--text-salmon-pink-color)"}
							>
								*
							</Typography>
						</BaseLabel>
						<BaseInput
							required
							name="homeAddress"
							value={formDetails.homeAddress}
							placeholder="Enter Home Address"
							onChange={(e) => handleChange(e)}
						/>
					</BaseFieldSet>
				</Grid2>
				<Grid2 size={{ mobile: 12, tablet: 6 }}>
					<BaseFieldSet>
						<BaseLabel colour="var(--dark-color)">
							Office Address{" "}
							<Typography
								component={"span"}
								fontFamily={"inherit"}
								fontWeight={"inherit"}
								fontSize={"inherit"}
								lineHeight={"inherit"}
								color={"var(--text-salmon-pink-color)"}
							>
								*
							</Typography>
						</BaseLabel>
						<BaseInput
							required
							name="officeAddress"
							value={formDetails.officeAddress}
							placeholder="Enter Office Address"
							onChange={(e) => handleChange(e)}
						/>
					</BaseFieldSet>
				</Grid2>
				<Grid2 size={{ mobile: 12, tablet: 6 }}>
					<BaseFieldSet>
						<BaseLabel colour="var(--dark-color)">
							Position Held{" "}
							<Typography
								component={"span"}
								fontFamily={"inherit"}
								fontWeight={"inherit"}
								fontSize={"inherit"}
								lineHeight={"inherit"}
								color={"var(--text-salmon-pink-color)"}
							>
								*
							</Typography>
						</BaseLabel>
						<BaseInput
							required
							name="position"
							value={formDetails.position}
							placeholder="Enter Position Held"
							onChange={(e) => handleChange(e)}
						/>
					</BaseFieldSet>
				</Grid2>
			</Grid2>
			{error && (
				<Typography
					fontFamily={"Inter"}
					fontWeight={"600"}
					fontSize={14}
					lineHeight={"normal"}
					color={"var(--text-salmon-pink-color)"}
					whiteSpace={"normal"}
				>
					{error}
				</Typography>
			)}
			<Box overflow={"hidden"}>
				<BaseButton
					type="submit"
					variant="contained"
					bgcolor="var(--primary-color)"
					disableElevation
					sx={{
						width: { mobile: "100%", miniTablet: "auto" },
					}}
				>
					{isLoading ? (
						<CircularProgress color="inherit" className="loader" />
					) : (
						<Typography
							variant={"button"}
							fontFamily={"inherit"}
							fontWeight={"inherit"}
							fontSize={"inherit"}
							lineHeight={"inherit"}
							color={"inherit"}
							textTransform={"inherit"}
						>
							Add Guarantor
						</Typography>
					)}
				</BaseButton>
			</Box>
		</AddGuarantorWrapper>
	);
};
